import { useMemo } from "react";
import { ActivityDataPoint } from "../../../ActivityChart";

export function useSuspiciousMinute(chartData: ActivityDataPoint[]) {
  return useMemo(() => {
    const suspicious = chartData.find((d) => d.isBurst);
    return suspicious?.minute ?? null;
  }, [chartData]);
}
